import { Button, Cell, Heading, HFlow, Modal, ModalBody, ModalHeader, Text, VFlow } from 'bold-ui'
import atividadeColetivaDetalhe from 'images/atividade-coletiva/atividade-coletiva-detalhe.webp'
import atividadeColetivaMenu from 'images/atividade-coletiva/atividade-coletiva-menu.webp'
import atividadeColetivaObservacaoCidadao from 'images/atividade-coletiva/atividade-coletiva-observacao-cidadao.webp'
interface ModalNovidadesAtividadeColetivaProps {
  isModalOpen: boolean
  onClose(): void
}

export function ModalNovidadesAtividadeColetiva(props: Readonly<ModalNovidadesAtividadeColetivaProps>) {
  const { isModalOpen, onClose } = props

  return (
    <Modal size='large' open={isModalOpen} closeOnBackdropClick={true} onClose={onClose}>
      <ModalHeader title='Novidades no registro de atividades coletivas' />
      <ModalBody>
        <VFlow>
          <Text>
            Agora, o PEC passa a contar com o novo módulo de Atividade coletiva! Com o objetivo de otimizar o
            preenchimento existente na ficha e trazer evoluções ao processo de registro de atividades coletivas nas
            unidades, o novo módulo conta com:
            <ul>
              <li>Separação dos registros em Reuniões e Atividades em saúde;</li>
              <li>Visualização de registros de atividade coletiva de toda localidade do profissional;</li>
              <li>
                Gestão da listagem de registros através dos filtros de Profissional responsável, registros processados,
                período, tipo de atividade e equipe;
              </li>
              <li>Campo aberto para inclusão de anotações da atividade em saúde ou reunião;</li>
              <li>Preenchimento automático de dados do cidadão e do profissional;</li>
              <li>Cálculo e classificação automática de IMC;</li>
              <li>Inclusão de observações sobre cidadãos em registros de reunião.</li>
            </ul>
          </Text>
        </VFlow>
        <VFlow>
          <Heading level={4}>Nova visualização e gestão da listagem dos registros</Heading>
          <Text>
            Visualize separadamente as Reuniões e as Atividades coletivas em Saúde, cada tipo em sua própria listagem.
            Assim, você encontra rapidamente todos os registros já realizados pela unidade.
          </Text>
          <Cell size={5}>
            <img
              src={atividadeColetivaMenu}
              alt='Aba de navegação de Atividade coletiva'
              style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
          </Cell>
        </VFlow>
        <VFlow>
          <Heading level={4}>Registro de atividades</Heading>
          <Text>
            Agora, o registro das atividades está otimizado através do preenchimento automático de dados, além de contar
            com novo campo para detalhamento da atividade.
          </Text>
          <Cell size={9}>
            <img
              src={atividadeColetivaDetalhe}
              alt='Detalhe da página de registro de Atividade coletiva'
              style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
          </Cell>
        </VFlow>
        <VFlow>
          <Heading level={4}>Observações sobre o cidadão</Heading>
          <Text>
            Além disso, os registros de reunião contam com uma nova seção para inclusão de observações sobre cidadãos
            que foram discutidas durante a reunião de equipe.
          </Text>
          <Cell size={12}>
            <img
              src={atividadeColetivaObservacaoCidadao}
              alt='Detalhe do registro de observações sobre o cidadão'
              style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
          </Cell>
        </VFlow>
        <HFlow justifyContent='flex-end'>
          <Button onClick={onClose} kind='primary'>
            Entendi
          </Button>
        </HFlow>
      </ModalBody>
    </Modal>
  )
}
